const storage = {
    not_configured: 'Nhà cung cấp lưu trữ chưa được cấu hình.',
    missing_parameter: 'Thiếu tham số {{parameter}} cho nhà cung cấp lưu trữ.',
    upload_error: 'Tải tệp lên nhà cung cấp lưu trữ thất bại.',
    download_error: 'Tải tệp xuống từ nhà cung cấp lưu trữ thất bại.',
};
export default Object.freeze(storage);
